
export const handleAddCardClick = (
  id: string,
  setdata: Function,
  setShowRoleSelect: Function,
  setIsBranchSelected: Function
) => {
  setdata(id);
  setShowRoleSelect(true);
  setIsBranchSelected(true);
};

export const handleEditUser = (
  id: string,
  edit: boolean,
  setEdit: Function,
  setid: Function,
  setname: Function,
  Name: string,
  setphone: Function,
  Phone: string,
  setrole: Function,
  Role: string
) => {
  setEdit(!edit);
  setid(id);
  setname(Name);
  setphone(Phone);
  setrole(Role);
};

export const addUserButton = { Blue: "blue", name: "Add User", };
export const cancelButton = { Cancel: "blue", name: "cancel", };
export const confirmButton = { Blue: "blue", name: "Confirm", };
export const errorConfirmButton = { error: "blue", name: "Confirm", };
export const bButton = { Blue: "b", name: "Confirm", };
export const menu = { User: "user", };